import useFetcher from 'app/_utils/data/useFetcher';

import { Member } from 'shared/src/types';
import useSWR from 'swr';

export const useGetOrganizationOwners = (organizationId: string): ReturnType<
  typeof useSWR<Member[]>
> => {
  const { fetcher } = useFetcher();

  const organizationOwnersURL = `${process.env.ZEUS_API_URL}/v1/system/memberships/${organizationId}/owners`;

  return useSWR<Member[]>(organizationOwnersURL, (url: string) =>
    fetcher<Member[]>(url, { method: 'GET' }),
  );
};
